module.exports = __webpack_public_path__ + "img/405.3c00b30f.svg";